import * as React from "react";
import { Dispatch } from "redux";
import { connect } from "react-redux";
import { Redirect } from "react-router";
import { Row, Col } from "antd";

import { RootState } from "../../reducers";
import {loginUser} from "../../reducers/user/actions";
import {LoginForm} from "../../components/login-form";

import "./styles.less";

interface Props {
  error: string;
  isLoggingIn: boolean;
  isLoggedIn: boolean;
  dispatch: Dispatch<{}>;
}

class LoginContainerComponent extends React.Component<Props, {}> {
  render() {
    if (this.props.isLoggedIn) {
      return (
        <Redirect to="/" />
      );
    }

    return (
      <Row>
        <Col span={24}>
          <LoginForm
            onSubmit={(username: string, password: string) => this.props.dispatch(loginUser(username, password))}
            isLoggingIn={this.props.isLoggingIn}
            error={this.props.error}
          />
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  error: state.user.loggingInError,
  isLoggingIn: state.user.isLoggingIn,
  isLoggedIn: state.user.isLoggedIn,
});

export const LoginContainer = connect(mapStateToProps)(LoginContainerComponent);



// WEBPACK FOOTER //
// ./src/containers/login/index.tsx